module.exports = __webpack_public_path__ + "media/images/old-ticbalionlineshop-f608c03be84207855ba1e2377004b74d.png";